module.exports = __webpack_public_path__ + "img/533-5087f9.png";